import { createFeatureSelector, createSelector } from '@ngrx/store';
import { handleActions } from 'redux-actions';
import {
  IEntityList,
  IFilteredLists,
  initialListState,
  mergeNewEntities,
} from '../entity-data/entity-data.reducer';
import { EntityTypesEnum } from '../../app.enum';
import {
  documentReducerMap,
  IDocumentState,
} from '../document-data/document-data.reducer';
import { Schedule } from '../document-data/sub-models/schedule.model';
import { List } from 'immutable';
import { ActionsEnum, SetSchedulesList } from './invoice-data.actions';
import {
  DEFAULT_PAID_SEARCH_PARAMS,
  DEFAULT_SEARCH_PARAMS,
} from './invoice-data.data';

// feature name
export const FEATURE_NAME = 'invoice-data';

// state interface
export interface IState extends IDocumentState {
  schedules: List<Schedule>;
}

// initial state of store
export const initialDocumentListState: IEntityList = {
  ...initialListState,
  searchParams: DEFAULT_SEARCH_PARAMS,
};
export const initialPaidListState: IEntityList = {
  ...initialListState,
  searchParams: DEFAULT_PAID_SEARCH_PARAMS,
};

export const initialFilteredListsState: IFilteredLists = {
  paid: initialPaidListState,
  unpaid: initialDocumentListState,
  search: initialDocumentListState,
};

export const initialState: IState = {
  filteredLists: initialFilteredListsState,
  editingEntity: null,
  selectedEntities: null,
  masterError: null,
  dispatchedResponse: null,
  schedules: List([]),
  tmpCache: null,
};

// reducers
const reducerFn = handleActions(
  {
    ...documentReducerMap<IState>(),
    [ActionsEnum.SET_SCHEDULES_LIST]: function (
      state: IState,
      { payload }: SetSchedulesList
    ): IState {
      const { scheduleList, deletedIds } = payload;
      const newSchedules = mergeNewEntities(
        state.schedules || List([]),
        scheduleList || List([]),
        deletedIds || List([]),
        false,
        'invoiceId'
      );

      return {
        ...state,
        schedules: newSchedules,
      };
    },
  } as any,
  initialState
);

// filter actions by entityType
export function reducer(state: IState = initialState, action: any) {
  return action.payload && action.payload.entityType === EntityTypesEnum.invoice
    ? reducerFn(state, action)
    : state;
}

// selectors
export const selectFeature = createFeatureSelector<IState>(FEATURE_NAME);

export function getSchedules() {
  return createSelector(selectFeature, (state: IState) => state.schedules);
}
